"use client";

import * as React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { MapPin, Clock, Users } from "lucide-react";
function ToursGridConsumer() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  const [isDesktop, setIsDesktop] = React.useState(false);
  React.useEffect(() => {
    const checkDevice = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };
    checkDevice();
    window.addEventListener("resize", checkDevice);
    return () => window.removeEventListener("resize", checkDevice);
  }, []);
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="h-96 rounded-xl bg-muted/30 animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center text-muted-foreground py-12">
        <p className="mb-4">Failed to load tours.</p>
        <Button onClick={refetch} variant="outline">
          Retry
        </Button>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center text-muted-foreground py-12">
        <p>No tours available at the moment.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((tour, i) => {
      const featuredImage = tour._embedded?.["wp:featuredmedia"]?.[0]?.source_url;
      const whatsappNumber = "529841234567";
      const message = encodeURIComponent(`Hola EcoLuxMaya, me gustaría reservar el tour: ${tour.title}`);
      const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${message}`;
      return <Card key={tour.id} data-index={i} className="group overflow-hidden transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:shadow-medium hover:-translate-y-1">
            <div className="block">
              {featuredImage && <Link to={tour.link || "#"} className="block">
                  <div className="aspect-[4/3] overflow-hidden bg-muted">
                    <img src={featuredImage} alt={tour.title} className="h-full w-full object-cover transition-transform duration-[var(--duration-medium)] group-hover:scale-105" loading="lazy" />
                  </div>
                </Link>}
              <CardContent className="space-y-4 pt-6">
                <Link to={tour.link || "#"} className="block hover:text-primary-dark transition-colors">
                  <h3 className="text-xl font-display font-semibold text-foreground leading-tight">
                    {tour.title}
                  </h3>
                </Link>

                {tour.excerpt && <div className="text-sm text-muted-foreground line-clamp-3" dangerouslySetInnerHTML={{
              __html: tour.excerpt
            }} />}

                <div className="flex flex-wrap items-center gap-4 text-sm text-muted-foreground">
                  {tour.customFields?.duration && <div className="flex items-center gap-1.5">
                      <Clock className="size-4" />
                      <span>{tour.customFields.duration}</span>
                    </div>}
                  {tour.customFields?.location && <div className="flex items-center gap-1.5">
                      <MapPin className="size-4" />
                      <span>{tour.customFields.location}</span>
                    </div>}
                  {tour.customFields?.group_size && <div className="flex items-center gap-1.5">
                      <Users className="size-4" />
                      <span>{tour.customFields.group_size}</span>
                    </div>}
                </div>

                {tour.customFields?.price && <div className="flex items-baseline gap-2">
                    <span className="text-2xl font-bold text-primary-dark">
                      ${tour.customFields.price}
                    </span>
                    <span className="text-sm text-muted-foreground">per person</span>
                  </div>}

                <div className="flex flex-col gap-3 pt-2">
                  <Link to={whatsappUrl} newTab={isDesktop} className="btn-primary w-full text-center py-3 text-sm font-semibold uppercase tracking-wider">
                    Book Now
                  </Link>
                  <Link to={tour.link || "#"} newTab={false} className="btn-primary w-full text-center py-3 text-sm font-semibold uppercase tracking-wider">
                    View Experience
                  </Link>
                </div>
              </CardContent>
            </div>
          </Card>;
    })}
    </div>;
}
export default function ToursGrid() {
  return null;
}